/* unplugin-vue-components disabled */import script from "./ApplicationReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationReviewCard.vue?vue&type=style&index=0&id=0e7c1fe5&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e7c1fe5"]])

export default __exports__